import { DIMENSION_GROUPS, useGetDimensionGroup } from '@beef/ui-kit/hooks';
import { BUTTON_SIZES_BY_RESOLUTION } from "./constants";
export var useButtonConfig = function useButtonConfig() {
  var resolution = useGetDimensionGroup();
  return {
    size: BUTTON_SIZES_BY_RESOLUTION[resolution],
    fullWidth: resolution === DIMENSION_GROUPS.mobile
  };
};